import { render, staticRenderFns } from "./DeveloperInfo.vue?vue&type=template&id=ed907a76&scoped=true&"
import script from "./DeveloperInfo.vue?vue&type=script&lang=ts&"
export * from "./DeveloperInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperInfo.vue?vue&type=style&index=0&id=ed907a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed907a76",
  null
  
)

export default component.exports